// extracted by mini-css-extract-plugin
export default {"notice":"PrivacyPolicy_notice__FLQlQ","content":"PrivacyPolicy_content__-laXc"};